/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DC API — AINA available free doubts (from source)
 * Subset of DC API for `availableFreeDoubtsFromSource`. Use multi-API client `clientName: "doubtsDCAPI"` with base URL including `/apis` (e.g. VITE_DOUBTS_DCAPI).
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AinaAvailableFreeDoubtsFromSourceResponse,
  GetAinaAvailableFreeDoubtsFromSourceParams,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Check available AINA free doubts from source
 */
export const getAinaAvailableFreeDoubtsFromSource = (
  params: GetAinaAvailableFreeDoubtsFromSourceParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AinaAvailableFreeDoubtsFromSourceResponse>(
    {
      url: `/dc/1/availableFreeDoubtsFromSource`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetAinaAvailableFreeDoubtsFromSourceQueryKey = (
  params?: GetAinaAvailableFreeDoubtsFromSourceParams,
) => {
  return [
    `/dc/1/availableFreeDoubtsFromSource`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAinaAvailableFreeDoubtsFromSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetAinaAvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAinaAvailableFreeDoubtsFromSourceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>
  > = ({ signal }) =>
    getAinaAvailableFreeDoubtsFromSource(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAinaAvailableFreeDoubtsFromSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>
>;
export type GetAinaAvailableFreeDoubtsFromSourceQueryError = unknown;

export function useGetAinaAvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetAinaAvailableFreeDoubtsFromSourceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
          TError,
          Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAinaAvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetAinaAvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
          TError,
          Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAinaAvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetAinaAvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check available AINA free doubts from source
 */

export function useGetAinaAvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetAinaAvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAinaAvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAinaAvailableFreeDoubtsFromSourceQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
